// Static site data for Alfa Exterior Cleaning & Services
import {
  Droplets,
  Home as HomeIcon,
  Wind,
  SprayCan,
  Sparkles,
  Construction,
  Wrench,
  SunMedium,
  Beaker,
  Trash2,
  Layers,
} from "lucide-react";

export const BUSINESS = {
  name: "Alfa Exterior Cleaning & Services",
  short: "Alfa Exterior",
  tagline: "Transforming Exteriors, Protecting Your Property.",
  slogan: "Goodbye grime, hello shine.",
  phone: "07469 667544",
  phoneTel: "+447469667544",
  email: "alfielewis@alfaexteriorcleaning.com",
  areas: ["Colchester", "Essex", "Frating", "Surrounding areas"],
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61572123232348",
    instagram: "https://www.instagram.com/alfaexteriorcleaning/",
  },
};

export const TRUST_ITEMS = [
  { label: "Fully Insured", desc: "Public liability covered" },
  { label: "100% Recommended", desc: "By local homeowners" },
  { label: "Free Quotations", desc: "No-obligation visits" },
  { label: "Commercial & Residential", desc: "Homes, offices, sites" },
];

export const SERVICES = [
  {
    id: "driveway",
    title: "Driveway & Patio Cleaning",
    description:
      "Deep pressure washing and re-sanding for block paving, Indian sandstone, slabs and concrete. Dirt, algae, lichen, cement and rust — lifted.",
    image:
      "https://customer-assets.emergentagent.com/job_property-protect-5/artifacts/afjq1ppf_4.jpeg",
    icon: Droplets,
  },
  {
    id: "roof",
    title: "Roof Cleaning & Scraping",
    description:
      "Safe moss, algae and lichen removal, followed by a biocide treatment to inhibit regrowth and extend the life of your tiles.",
    image:
      "https://customer-assets.emergentagent.com/job_property-protect-5/artifacts/ejpr8rag_2.jpeg",
    icon: HomeIcon,
  },
  {
    id: "gutters",
    title: "Gutter Cleaning & Clearances",
    description:
      "Full clear-outs of compacted moss, leaves and debris. Keep rainwater flowing and stop damp working its way into your walls.",
    image:
      "https://images.pexels.com/photos/35153375/pexels-photo-35153375.jpeg?auto=compress&cs=tinysrgb&w=900",
    icon: Wind,
  },
  {
    id: "fascia-soffit",
    title: "Fascia & Soffit Cleaning",
    description:
      "Restore tired, streaked fascias and soffits caused by overflowing gutters. Bright white finish, top to bottom.",
    icon: Layers,
  },
  {
    id: "soft-wash",
    title: "Soft Washing",
    description:
      "Low-pressure cleaning for render, brick and delicate surfaces — powerful results, zero damage.",
    image:
      "https://images.pexels.com/photos/5652626/pexels-photo-5652626.jpeg?auto=compress&cs=tinysrgb&w=900",
    icon: SprayCan,
  },
  {
    id: "windows",
    title: "Window Cleaning",
    description:
      "Streak-free finishes using pure water pole systems. Indoor and outdoor, ground to gable.",
    image:
      "https://customer-assets.emergentagent.com/job_property-protect-5/artifacts/7jfand5n_12.jpg",
    icon: Sparkles,
  },
  {
    id: "tarmac",
    title: "Tarmac Restoration",
    description:
      "Bring tired tarmac back to factory black. Specialist sealants for a long-lasting finish.",
    image:
      "https://customer-assets.emergentagent.com/job_property-protect-5/artifacts/5q39lzkn_11.jpg",
    icon: Construction,
  },
  {
    id: "oil-rust",
    title: "Oil & Rust Removal",
    description:
      "Stubborn oil spills, rust patches and tyre marks lifted from driveways and forecourts.",
    image:
      "https://images.pexels.com/photos/14965464/pexels-photo-14965464.jpeg?auto=compress&cs=tinysrgb&w=900",
    icon: Wrench,
  },
  {
    id: "solar",
    title: "Solar Panel Cleaning",
    description:
      "Restore lost output — dirt, lichen and bird droppings gently cleaned off with deionised water. Safe for your panels and warranty.",
    image:
      "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=900&q=80",
    icon: SunMedium,
  },
  {
    id: "biocide",
    title: "Biocide Treatments",
    description:
      "Applied after cleaning to slow the return of moss, algae and lichen — keeping roofs, patios and paths cleaner for longer.",
    icon: Beaker,
  },
  {
    id: "wheelie-bin",
    title: "Wheelie Bin Cleaning",
    description:
      "Deep clean and deodorise your household bins. Bacteria, smells and stains gone — kerbside ready.",
    icon: Trash2,
  },
];

// Real transformation footage supplied by Alfa Exterior Cleaning.
export const TRANSFORMATIONS = [
  {
    id: "block-paving",
    title: "Block Paving Transformation",
    location: "Frating",
    caption: "Recent driveway revival — moss, algae and ground-in grime scrubbed back to new.",
    poster: "/posters/block-paving.jpg",
    src: "https://customer-assets.emergentagent.com/job_property-protect-5/artifacts/6g530oaw_2.mp4",
  },
  {
    id: "brick-driveway",
    title: "Brick Carport Deep Clean",
    location: "Essex",
    caption: "Heavy moss removal across a textured brick carport driveway.",
    poster:
      "https://customer-assets.emergentagent.com/job_property-protect-5/artifacts/a85vcxc6_3.jpeg",
    src: "https://customer-assets.emergentagent.com/job_property-protect-5/artifacts/3czkgxv7_3.mp4",
  },
  {
    id: "roof-cleaning",
    title: "Roof Cleaning & Moss Removal",
    location: "Essex",
    caption: "Safe roof scrape and moss removal — protecting tiles from long-term wear.",
    poster: "/posters/roof-cleaning.jpg",
    src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_property-protect-5/artifacts/z8hnu9wp_new.mp4",
  },
];

// Real before / after pairs supplied by Alfa Exterior Cleaning.
export const BEFORE_AFTER = [
  {
    id: "conservatory-roof",
    title: "Conservatory Roof Clean",
    location: "Colchester",
    description:
      "Years of moss, algae and debris cleared from a tired conservatory roof — back to crystal-clear panels.",
    before:
      "https://customer-assets.emergentagent.com/job_property-protect-5/artifacts/86zzho4v_1.jpeg",
    after:
      "https://customer-assets.emergentagent.com/job_property-protect-5/artifacts/ejpr8rag_2.jpeg",
  },
  {
    id: "brick-carport",
    title: "Brick Carport Restoration",
    location: "Essex",
    description:
      "Heavy moss and grime lifted from herringbone block paving — the original warm red brick brought back to life.",
    before:
      "https://customer-assets.emergentagent.com/job_property-protect-5/artifacts/ye7uu8g8_3.jpeg",
    after:
      "https://customer-assets.emergentagent.com/job_property-protect-5/artifacts/afjq1ppf_4.jpeg",
  },
];

// Recent completed projects — pre-stacked before/after images supplied by Alfa Exterior Cleaning.
export const PROJECTS = [
  {
    id: "block-paving-drive",
    title: "Block Paving Driveway & Re-Sanding",
    location: "Essex",
    tags: ["Driveway", "Re-Sanding"],
    description:
      "Complete driveway clean and re-sanding on herringbone block paving. Years of dirt, algae, lichen, cement and rust removed using professional pressure washing and specialist chemical treatments — new-looking driveway, better kerb appeal and a safer, less slippery surface.",
    image:
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_property-protect-5/artifacts/w1hpc4h3_WhatsApp%20Image%202026-09-07%20at%2013.23.45.webp",
  },
  {
    id: "indian-sandstone",
    title: "Indian Sandstone Patio Clean",
    location: "Essex",
    tags: ["Patio", "Biocide"],
    description:
      "Full Indian sandstone patio clean using specialist methods suitable for natural stone, plus the side pathway. Followed up with a biocide treatment to slow the return of moss, algae and lichen — keeping the patio cleaner and safer for longer.",
    image:
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_property-protect-5/artifacts/xftauxpt_WhatsApp%20Image%202026-09-07%20at%2013.23.45%20%281%29.webp",
  },
  {
    id: "oil-rust-treatment",
    title: "Rust & Stain Removal",
    location: "Essex",
    tags: ["Oil & Rust", "Chemical Treatment"],
    description:
      "Close-up of a specialist chemical treatment lifting stubborn rust and oil marks from block paving — the kind of stain a pressure washer alone can't shift.",
    image:
      "https://customer-assets-gfyr7b9c.emergentagent.net/job_property-protect-5/artifacts/g5p53v85_WhatsApp%20Image%202026-09-07%20at%2013.23.45%20%282%29.webp",
  },
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_property-protect-5/artifacts/fv9j2xox_logo.jpeg";

export const REVIEW_STATS = {
  source: "Facebook",
  recommendPercent: 100,
  count: 8,
  url: "https://www.facebook.com/profile.php?id=61572123232348",
};

export const TESTIMONIALS = [
  {
    name: "Ollie Covey",
    location: "Colchester",
    rating: 5,
    text:
      "I can't recommend Alfa Exterior Cleaning enough. They recently jet-washed my patio and the transformation is unbelievable — it genuinely looks like a brand-new patio. Years of dirt, algae and staining have completely gone. Turned up when they said they would, worked hard, were professional throughout and left everything clean and tidy. Fantastic service, great value for money — I'll definitely be using them again.",
  },
  {
    name: "Orhan Dağdelen",
    location: "Local customer",
    rating: 5,
    text:
      "Excellent window cleaning service! The team arrived on time, worked efficiently, and left every window sparkling clean. They paid attention to detail and were very professional throughout the job. Highly recommended for anyone looking for quality service.",
  },
  {
    name: "Steve Masters",
    location: "Local customer",
    rating: 5,
    text:
      "Alfa Exterior Cleaning completed the job with a professional attitude and dedication. No fuss, had great equipment and the finish was better than I imagined. Very happy indeed — also competitively priced which is a bonus.",
  },
  {
    name: "Billy de Vries",
    location: "Local customer",
    rating: 5,
    text:
      "Took my slate roof from looking uncared for to brand new. Really professional customer service — highly recommend.",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1710883734889-5a0b8ab6bfcf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob21lJTIwZXh0ZXJpb3IlMjB1a3xlbnwwfHx8fDE3ODE1MzcyNzB8MA&ixlib=rb-4.1.0&q=85";
